import { setNewHeaders } from "actions";
import axios from "axios";
import { API_URL_login } from "constants/api";
import { toast } from "react-toastify";
import { authReducer } from "redux/authSlice";

export const loginUser = (dispatch, data) => {
  dispatch(
    authReducer({
      type: "LOGIN_USER",
      payload: {
        loading: true,
        data: false,
      },
    })
  );

  axios({
    method: "POST",
    url: API_URL_login,
    timeout: 120000,
    data: data,
  })
    .then((response) => {
      setNewHeaders(response.data);
      dispatch(
        authReducer({
          type: "LOGIN_USER",
          payload: {
            loading: false,
            data: response.data,
          },
        })
      );
    })
    .catch((err) => {
      let customError;
      if (err.response) {
        if (
          err.response.data.detail ===
          "No active account found with the given credentials"
        ) {
          customError = "Username atau Password Salah";
        }
      }
      toast.error(customError ?? err.message, {
        position: "top-center",
        autoClose: true,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      dispatch(
        authReducer({
          type: "LOGIN_USER",
          payload: {
            loading: false,
            data: false,
          },
        })
      );
    });
  return true;
};
